<style lang="scss" src='./WeatherAlerts.scss' scoped></style>
<template src="./WeatherAlerts.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import GwExport from '@/components/gwExport/GwExport.vue';
import ApexChart from 'vue-apexcharts';
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';

import Datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import {
    getWeatherAlertsReport
} from '@/api/index';

import i18n from './../../../../i18n';

let CounterForUpdatesCol = 0;
let CounterForUpdatesStack = 0; 
let CounterForUpdatesPie = 0;
let alertsArray = [];

const perPage = 100;
const pdfMaxWidth = 1120;
const chartWidth12 = "1050px";
const chartWidth6 = "500px";
const chartWidth4 = "350px";

export default {
    name: 'WeatherAlerts',
    extends: SecurityComponent,
    components: {
        ApexChart,
        VueHtml2pdf,
        GwExport,
        Datepicker
    },
    data() {
        return {
            chartMaxWidth12: '100%',
            chartMaxWidth6: '100%',
            chartMaxWidth4: '100%',
            selectedDateRange: null,
            stickyData: true,
            pdfName: null,
            loading: false,
            filters: {
                daysBack: null,
                threshold: null,
            },
            alerts: [],
            alertsLength: 0,
            column_series: [],
            column_x_cats: [],
            stack_series: [],
            stack_x_cats: [],
            pie_series: [],
            pie_cats: [],
            alert_types: [],
            types_amounts: {},
            options: [
                { text: this.$t('timePeriods.1DLong'), label: this.$t('timePeriods.last24H'), value: 1, },
                { text: this.$t('timePeriods.2DLong'), label: this.$t('timePeriods.last2D'), value: 2, },
                { text: this.$t('timePeriods.1WLong'), label: this.$t('timePeriods.lastWeek'), value: 7, },
                { text: this.$t('timePeriods.1MLong'), label: this.$t('timePeriods.lastMonth'), value: 30, },
                { text: this.$t('timePeriods.1YLong'), label: this.$t('timePeriods.lastYear'), value: 365, },
                { text: 'By Date', label: 'By Date', value: 0, },
            ],
            basicColCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            stackedColCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            pieCharOpt: {
            },
            pagination: {
                page: 1,
                start: 0,
                end: 0
            },
            pdf: {},
        };
    },
    computed: {
        getAlerts() {
            return this.alerts;
        },
        canGetNextPage(){
            return this.pagination.page * perPage < this.alertsLength;
        }
    },
    methods: {
        getCsvData(){
            if(alertsArray.length>0){
                let data = alertsArray.map((item)=>{
                    let obj = {}
                    obj[i18n.t('general.date')] = this.G_formatDate({date: (item.time_open + "Z"), pretty: false});
                    obj[i18n.t('dashboard.alertType')] = this.getAlertTypeTranslation(item.alert_type_id);
                    obj[i18n.t('reports.stationName')] = item.name;
                    obj[i18n.t('weatherStation.serialNumber')] = item.device_sn;
                    obj[i18n.t('general.description')] = this.G_getAletDescription({ violation: item.violation, alertType: item.alert_type_id });
                    obj[i18n.t('reports.reading')] = this.G_getMeasurement({ val: item.reading,
                                                uom: this.getAlertTypeUOM(item.alert_type_id),
                                                addUnit: true, invertUOM: false });
                    return obj
                })
                return data;
            }
            return [];
        },

        showNextPage(){
            if(this.canGetNextPage){
                this.pagination.page += 1;
                this.pagination.start += perPage;
                let newEnd = this.pagination.end + perPage;
                this.pagination.end = (this.alertsLength >= newEnd) ? newEnd : this.alertsLength;
            }
            this.getAlertsByPage();
        },
        
        showPrevPage(){
            if(this.pagination.page > 1){
                this.pagination.page -= 1;
                this.pagination.start -= perPage;
                this.pagination.end = this.pagination.start + perPage - 1;
            }
            this.getAlertsByPage();
        },

        getAlertsByPage(){
            this.alerts = alertsArray.slice(this.pagination.start - 1, this.pagination.end);
        },

        filterByDays(daysBack) {
            this.options[5].value = 0
            if(this.filters.daysBack != daysBack){
                this.selectedDateRange = null;
                this.loading = true;
                this.resetValues();
                this.filters.daysBack = daysBack;
                this.getGraph();
            }
        },
        async handleDateRangeChange(dates) {
            this.options[5].value = 0
            this.loading = true;
            this.resetValues();
            let date = null;
            if(dates[0]){                
                const startDate = moment(dates[0]).format('YYYY-MM-DD')
                const endDate = moment(dates[1]).format('YYYY-MM-DD')
                const start = new Date(startDate);
                const end = new Date(endDate);
                const timeDiff = Math.abs(end.getTime() - start.getTime());
                const days = Math.ceil(timeDiff / (1000 * 3600 * 24));
                this.filters.daysBack = this.options[5] 
                this.filters.daysBack.value = days
                date = {
                startDate, 
                endDate
            };
            
            }
            await this.getGraph(date);
            
        },

        resetValues() {
            alertsArray = [];
            this.alerts = [];
            this.alertsLength = 0;
            this.column_series = [];
            this.column_x_cats = [];
            this.stack_series = [];
            this.stack_x_cats = [];
            this.pie_series = [];
            this.alert_types = [];
            this.pie_cats = [];
            this.types_amounts = {};
            this.pagination= {
                page: 1,
                next: false
            }
        },
        
        exportReport(item){
            this.$refs.stationAlertPDF.generatePdf();
        },

        loadData() {
            this.loading = true;
            this.getGraph();
        },

        async getGraph(date){
            let tempChartOptions = this.getBasicColumnChartOptions();
            let tempStackChartOptions = this.getStackedColumnsChartOptions();
            let tempPieChartOptions = this.getPieChartOptions();
            const daysBack = this.filters.daysBack;
            let resample = null
            if (daysBack.value == 7) {
                resample = '30min';
            } else if (daysBack.value > 7 && daysBack.value <= 30) {
                resample = '1h';
            } else if (daysBack.value > 30) {
                resample = '8h';
            }

            const data = {
                courseId: this.$store.state.course.course_id,
                until: this.filters.daysBack.value,
                resampleFreq: resample
            };

            if(date){
                data['startDate'] = date.startDate;
                data['endDate'] = date.endDate;
            }

            let apiCall = getWeatherAlertsReport;
            
            await apiCall(data).then((res) => {
                this.alertsLength = res.alerts.length;
                
                if (res.alerts.length > 0) {
                    alertsArray = res.alerts;
                    this.pagination.start = 1;
                    this.pagination.end = (this.alertsLength >= perPage) ? perPage : this.alertsLength;
                    this.getAlertsByPage();
                }
                
                if (res.by_type.length > 0){
                    for (var i = 0; i < res.by_type.length; i++) {
                        this.alert_types.push(res.by_type[i].alert_type_id);
                        this.pie_series.push(parseInt(res.by_type[i].amount));
                        this.types_amounts[res.by_type[i].alert_type_id] = 0;

                        
                        let i18n_key = this.consts.AlertType[res.by_type[i].alert_type_id].i18n;
                        let name = (i18n_key != undefined && i18n_key != null) ? i18n.t(i18n_key) : res.by_type[i].alert_type_id;
                        
                        this.pie_cats.push(name);
                    }

                    tempPieChartOptions.labels = this.pie_cats;
                }

                this.pieCharOpt = tempPieChartOptions;
                
                if (res.by_time.length > 0){
                    let byTimeData = {};

                    for (var i = 0; i < res.by_time.length; i++){
                        let dateKey = '';
                        
                        if (this.filters.daysBack.value == 1 || this.filters.daysBack.value == 2){
                            dateKey = res.by_time[i].day + ' ' + res.by_time[i].hour + ':00 UTC';
                        }else {
                            dateKey = res.by_time[i].day + ' UTC';
                        }

                        if (!(dateKey in byTimeData)){
                            byTimeData[dateKey] = {...this.types_amounts};
                        }

                        if (this.alert_types.includes(res.by_time[i].alert_type_id)){
                            byTimeData[dateKey][res.by_time[i].alert_type_id] += parseInt(res.by_time[i].amount);
                        }
                    }

                    let tempSeries = {}
                    for (const [key, value] of Object.entries(byTimeData)) {
                        this.column_x_cats.push(key);

                        for (const [k, v] of Object.entries(value)) {
                            if (!(k in tempSeries)){
                                tempSeries[k] = [];
                            }
                            tempSeries[k].push(v);
                        }
                    }
                    
                    for(const [key, value] of Object.entries(tempSeries)){
                        let i18n_key = this.consts.AlertType[key].i18n;
                        let name = (i18n_key != undefined && i18n_key != null) ? i18n.t(i18n_key) : key;
                        
                        this.column_series.push({'name': name, 'data': value})
                    }

                    tempChartOptions.xaxis.categories = this.column_x_cats;
                }

                this.basicColCharOpt = tempChartOptions;
                
                if(res.by_station.length > 0){
                    let bySensorData = {};

                    for (var i = 0; i < res.by_station.length; i++){
                        
                        let locationKey = res.by_station[i].name;

                        if (!(locationKey in bySensorData)){
                            bySensorData[locationKey] = {...this.types_amounts};
                        }

                        if (this.alert_types.includes(res.by_station[i].alert_type_id)){
                            bySensorData[locationKey][res.by_station[i].alert_type_id] += parseInt(res.by_station[i].amount);
                        }
                    }

                    let tempSeries = {}
                    for (const [key, value] of Object.entries(bySensorData)) {
                        this.stack_x_cats.push(key);

                        for (const [k, v] of Object.entries(value)) {
                            if (!(k in tempSeries)){
                                tempSeries[k] = [];
                            }
                            tempSeries[k].push(v);
                        }
                    }

                    for(const [key, value] of Object.entries(tempSeries)){
                        let i18n_key = this.consts.AlertType[key].i18n;
                        let name = (i18n_key != undefined && i18n_key != null) ? i18n.t(i18n_key) : key;
                        
                        this.stack_series.push({'name': name, 'data': value})
                    }
                    tempStackChartOptions.xaxis.categories = this.stack_x_cats;
                }

                this.stackedColCharOpt = tempStackChartOptions;
                
            });
            this.loading = false;
        },

        getBasicColumnChartOptions() {
            return {
                chart: {
                    type: 'bar',
                    animations: {
                        enabled: false,
                    },

                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesCol != 0) {
                                var elmnt = document.getElementById("column_chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesCol;
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    opacity: 1,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '50%'
                    },
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val ? (val < 5 ? (val).toFixed(1) : Math.round(val)) : 0;
                        },
                    },
                    title: {
                        text: ''
                    },
                    min: 0
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        datetimeUTC: false,
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: "MMM 'yy",
                            day: 'dd MMM',
                            hour: 'h:mm TT',
                        },
                    },
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: (val) => {
                            return this.G_formatDate({date: val, pretty: false});
                        }
                    },
                    shared: false,
                    y: {
                        formatter: (val) => {
                            return val ? val : 0;
                        }
                    }
                }
            }
        },

        getStackedColumnsChartOptions(){
            return {
                chart: {
                    type: 'bar',
                    animations: {
                        enabled: false,
                    },
                    stacked: true,

                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesStack != 0) {
                                var elmnt = document.getElementById("stacked_chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesStack;
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    opacity: 1,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '50%'
                    },
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val ? (val < 5 ? (val).toFixed(1) : Math.round(val)) : 0;
                        },
                    },
                    title: {
                        text: ''
                    },
                    min: 0
                },
                xaxis: {
                    type: 'category',
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: (val) => {
                            return val;
                        }
                    },
                    shared: false,
                    y: {
                        formatter: (val) => {
                            return val ? val : 0;
                        }
                    }
                },
            }
        },

        getPieChartOptions(){
            return {
                chart: {
                    type: 'pie',
                    animations: {
                        enabled: false,
                    },
                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesPie != 0) {
                                var elmnt = document.getElementById("pie_chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesPie;
                        }
                    }
                },
                dataLabels: {
                    enabled: true
                },
                title: {
                    text: '',
                    align: 'left'
                },
                fill: {
                    opacity: 1,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                legend: {
                    position: 'bottom'
                }
            }
        },

        getAlertTypeTranslation(alert_type_id){
            let i18n_key = this.consts.AlertType[alert_type_id].i18n;
            return (i18n_key != undefined && i18n_key != null) ? i18n.t(i18n_key) : alert_type_id;
        },

        getAlertTypeUOM(alert_type_id){
            return this.consts.AlertType[alert_type_id].uom;
        },

        async beforePDF({ html2pdf, options, pdfContent }){
            let container = this.$refs.reportContainer;
            let currentWidth = container.getBoundingClientRect().width;

            if(currentWidth >= pdfMaxWidth){
                this.chartMaxWidth12 = chartWidth12;
                this.chartMaxWidth6 = chartWidth6;
                this.chartMaxWidth4 = chartWidth4;
            }

            let date = new Date();
            this.pdf.date = moment(date).format("MM-DD-YYYY");
            this.pdf.time = this.filters.daysBack.text;

            this.stickyData = false;

            await html2pdf().set(options).from(pdfContent).toPdf().save();

            this.chartMaxWidth12 = "100%";
            this.chartMaxWidth6 = "100%";
            this.chartMaxWidth4 = "100%";
            this.stickyData = true;
        },

    },

    created() {
        let date = new Date();
        date = moment(date).format("MM-DD-YYYY");
        this.pdfName = i18n.t('reports.weatherAlerts') + ' ' + date;
    },

    async mounted() {
        alertsArray = [];
        this.filters.daysBack = this.options[0];
        this.loadData();
    },
};

</script>
